import { render, staticRenderFns } from "./SwappTasksSupervisor.vue?vue&type=template&id=baae29cc&scoped=true"
import script from "./SwappTasksSupervisor.vue?vue&type=script&lang=js"
export * from "./SwappTasksSupervisor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae29cc",
  null
  
)

export default component.exports